// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n", ""]);
// Exports
exports.locals = {
	"menuText": "#909EBA",
	"menuActiveText": "#FFFFFF",
	"subMenuActiveText": "#FFFFFF",
	"menuBg": "#304156",
	"menuHover": "#263445",
	"subMenuBg": "#161A25",
	"subMenuHover": "#001528",
	"sideBarWidth": "200px",
	"enSideBarWidth": "260px"
};
module.exports = exports;
